<template>
  <div id="audit-customer-list">
    <list-by-time-and-customer-id-and-group
      :allow-printing="true"
      :audit-customer-group-id="$route.query.auditCustomerIdGroup"
      :from="$route.query.from"
      :to="$route.query.to"
      v-if="$route.query.auditCustomerIdGroup"
    ></list-by-time-and-customer-id-and-group>
    <list-by-time-and-customer-id
      :allow-printing="true"
      :audit-list-id="$route.query.auditListId"
      :customerId="$route.query.customerId"
      :from="$route.query.from"
      :to="$route.query.to"
      v-else-if="$route.query.auditListId"
    ></list-by-time-and-customer-id>
    <div class="container pb-5" v-else>
      <legend>Создать сверку</legend>
      <form @submit.prevent="makeAudit" class="form-group " style="max-width: 800px">
        <div class="row">
          <div class="col">
            <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"
                         input-class="form-control"
                         lang="ru"
                         placeholder="С"
                         v-model="date_start" valueType="format">
            </date-picker>
          </div>
          <div class="col">
            <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"
                         input-class="form-control"
                         lang="ru"
                         placeholder="По"
                         v-model="date_end" valueType="format">
            </date-picker>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <v-select :options="customers" :reduce="customer => customer.Id" label="Reception"
                      placeholder="Выберите партнера" v-model="customer_id">
              <template #search="{attributes, events}">
                <input
                  :required="!customer_id"
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  v-on:keydown.enter.prevent
                />
              </template>
            </v-select>
          </div>
          <div class="col">
            <button class="btn btn-outline-success" type="submit">Создать</button>
          </div>
        </div>
      </form>


      <div>
        <legend>
          Список сверок
        </legend>
        <!--        <pre>-->
        <!--          {{notClosedAuditList.naAuditGrouped['ДЛ']}}-->
        <!--        </pre>-->
        <table class="table table-hover table-bordered table-sm">
          <tbody v-for="(groupAudit, groupName) in notClosedAuditList.naAuditGrouped"
                 class="border"
                 :key="groupName">
          <tr>
            <td colspan="6" class="font-weight-bold">
              <a href="#" @click.prevent="toggleCollapse(groupName)">{{
                  collapse[groupName] ? 'Закрыть' : 'Открыть'
                }} {{ groupName }}</a>

              <span v-if="!Object.keys(nonPaidCustomerDates).length" class="float-right">загрузка...</span>
              <span v-else-if="nonPaidCustomerDates[groupName]" class="float-right">
              <router-link
                v-for="nonPaidCustomerDate in nonPaidCustomerDates[groupName]"
                :key="nonPaidCustomerDate"
                :to="{ name: 'audit-customer-list', query: {
                                          auditCustomerIdGroup:groupName,
                                          yearMonth: nonPaidCustomerDate,
                                        }}"
                class="float-right ml-3"
              >
                {{ nonPaidCustomerDate }}
              </router-link>
              </span>
              <span v-else class="float-right">Закрыто</span>
            </td>
          </tr>

          <tr v-show="collapse[groupName]" v-for="(al, index) in groupAudit" :key="index"
              :class="{
                              'bg-success': al.CustomerApproved && !(al.AuditListItemsHasAuditDescription && al.AuditListItemsIsNotApprovedCount),
                              'bg-danger': (al.AuditListItemsHasAuditDescription && al.AuditListItemsIsNotApprovedCount)
                          }">
            <td style="width: 200px;">
              {{ al.DateStart }} - {{ al.DateEnd }}
            </td>
            <td>{{ al.Reception }}</td>
            <td width="200">
                            <span
                              :class="al.htmlClass"
                            >{{ al.htmlText }}</span>
            </td>
            <td style="width: 100px;">
              <router-link :to="{ name: 'audit-customer-list', query: {
                                        auditListId:al.Id,
                                      }}">
                Открыть
              </router-link>
            </td>
            <td style="width: 100px;">{{ al.TotalSummary }}</td>
            <td>
              <a target="_blank"
                 :href="'https://api.bn.tables.sferazakaz.ru/audit/customer-audit-item/' + al.Id + '/audit-link-by-id'">Сверка
                партнера</a>
            </td>
          </tr>
          <tr v-show="collapse[groupName]">
            <td colspan="6" class="font-weight-bold text-secondary bg-light">Конец группы
              {{ groupName }}
            </td>
          </tr>
          </tbody>
          <tbody>
          <tr v-for="al in notClosedAuditList.naNoAuditGrouped"
              :class="{
                            'bg-success': al.CustomerApproved && !(al.AuditListItemsHasAuditDescription && al.AuditListItemsIsNotApprovedCount),
                            'bg-danger': (al.AuditListItemsHasAuditDescription && al.AuditListItemsIsNotApprovedCount)
                        }">
            <td style="width: 200px;">
              {{ al.DateStart }} - {{ al.DateEnd }}
            </td>
            <td>{{ al.Reception }}</td>
            <td width="200">
                          <span
                            :class="al.htmlClass"
                          >{{ al.htmlText }}</span>
            </td>
            <td style="width: 100px;">
              <router-link :to="{ name: 'audit-customer-list', query: {
                                      auditListId:al.Id,
                                    }}">
                Открыть
              </router-link>
            </td>
            <td style="width: 100px;">{{ al.TotalSummary }}</td>
            <td>
              <a target="_blank"
                 :href="'https://api.bn.tables.sferazakaz.ru/audit/customer-audit-item/' + al.Id + '/audit-link-by-id'">Сверка
                партнера</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div>
        <legend>
          Закрытые сверки <a href="#" v-show="closedAuditList.length"
                             @click.prevent="showClosedAudit = !showClosedAudit">
          {{ !showClosedAudit ? 'Открыть' : 'Закрыть' }}
        </a>
        </legend>

        <table class="table table-hover table-bordered table-sm"
               v-if="closedAuditList.length && showClosedAudit">
          <tbody>
          <tr v-for="al in closedAuditList">
            <td style="width: 200px;">
              {{ al.DateStart }} - {{ al.DateEnd }}
            </td>
            <td>{{ al.Reception }}</td>
            <td width="200">
                      <span
                        :class="al.htmlClass"
                      >{{ al.htmlText }}</span>
            </td>
            <td style="width: 100px;">
              <router-link :to="{ name: 'audit-customer-list', query: {
                            auditListId:al.Id,
                          }}">
                Открыть
              </router-link>
            </td>
            <td style="width: 100px;">{{ al.TotalSummary }}</td>
            <td>
              <a target="_blank"
                 :href="'https://api.bn.tables.sferazakaz.ru/audit/customer-audit-item/' + al.Id + '/audit-link-by-id'">Сверка
                партнера</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>


      <!--      <legend>Сверки</legend>-->
      <!--      <div class="form-group row" style="width: 600px">-->
      <!--        <div class="col">-->
      <!--          <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"-->
      <!--                       input-class="form-control"-->
      <!--                       lang="ru"-->
      <!--                       placeholder="С"-->
      <!--                       v-model="from" valueType="format">-->
      <!--          </date-picker>-->
      <!--        </div>-->
      <!--        <div class="col">-->
      <!--          <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"-->
      <!--                       input-class="form-control"-->
      <!--                       lang="ru"-->
      <!--                       placeholder="По"-->
      <!--                       v-model="to" valueType="format">-->
      <!--          </date-picker>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <legend>Незакрытые заказы</legend>-->

      <!--      <table class="table table-sm table-hover">-->
      <!--        <thead></thead>-->
      <!--        <tbody>-->
      <!--        <tr v-for="item in customersToAudit">-->
      <!--          <td>{{item.Reception}}</td>-->
      <!--          <td width="100">{{item.OrderCount}}</td>-->
      <!--          <td width="100">-->
      <!--            <router-link :to="{ name: 'audit-customer-list', query: {-->
      <!--              from,-->
      <!--              to,-->
      <!--              customerId: item['c.Id']-->
      <!--            }}">-->
      <!--              Открыть-->
      <!--            </router-link>-->
      <!--          </td>-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->

      <!--      <legend class="mt-5">Закрытые заказы</legend>-->

      <!--      <table class="table table-sm table-hover">-->
      <!--        <thead></thead>-->
      <!--        <tbody>-->
      <!--        <tr v-for="item in closedAudit">-->
      <!--          <td>{{item.Reception}}</td>-->
      <!--          <td width="100">{{item.OrderCount}}</td>-->
      <!--          <td width="100">-->
      <!--            <router-link :to="{ name: 'audit-customer-list', query: {-->
      <!--              from,-->
      <!--              to,-->
      <!--              customerId: item['c.Id']-->
      <!--            }}">-->
      <!--              Открыть-->
      <!--            </router-link>-->
      <!--          </td>-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->
    </div>
  </div>
</template>
<script>
import ListByTimeAndCustomerId from '@/admin/modules/Audit/_components/ListByTimeAndCustomerId.vue';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';
import ListByTimeAndCustomerIdAndGroup
  from '@/admin/modules/Audit/_components/ListByTimeAndCustomerIdAndGroup.vue';

const queryString = require('query-string');

const currentDate = new Date();
// const defaultDateFrom = moment().subtract(20, 'days').format('YYYY-MM-DD');
// const defaultDateTo = moment().format('YYYY-MM-DD');

export default {
  components: {
    ListByTimeAndCustomerIdAndGroup,
    DatePicker,
    ListByTimeAndCustomerId,
  },
  data() {
    return {
      collapse: {},
      from: null,
      to: null,
      date_start: null,
      date_end: null,
      datesLoaded: false,
      customersToAudit: [],
      closedAudit: [],
      customers: [],
      customer_id: null,
      auditList: [],
      showClosedAudit: false,
      nonPaidCustomerDates: {},
    };
  },
  computed: {
    last01Month() {
      return moment(currentDate)
        .add(1, 'months')
        .endOf('month')
        .format('MM-YYYY');
    },
    last0Month() {
      return moment(currentDate)
        .endOf('month')
        .format('MM-YYYY');
    },
    last1Month() {
      return moment(currentDate)
        .subtract(1, 'months')
        .endOf('month')
        .format('MM-YYYY');
    },
    last2Month() {
      return moment(currentDate)
        .subtract(2, 'months')
        .endOf('month')
        .format('MM-YYYY');
    },
    last3Month() {
      return moment(currentDate)
        .subtract(3, 'months')
        .endOf('month')
        .format('MM-YYYY');
    },
    last4Month() {
      return moment(currentDate)
        .subtract(4, 'months')
        .endOf('month')
        .format('MM-YYYY');
    },
    closedAuditList() {
      if (this.auditList) {
        return _.filter(this.auditList, o => o.isClosed);
      }
      return [];
    },
    notClosedAuditList() {
      let na = [];
      if (this.auditList) {
        na = _.filter(this.auditList, o => !o.isClosed);

        let naAuditGrouped = _.filter(na, o => !!o.AuditGroup);
        naAuditGrouped = _.groupBy(naAuditGrouped, o => o.AuditGroup);

        const naNoAuditGrouped = _.filter(na, o => !o.AuditGroup);
        let keys = Object.keys(naAuditGrouped);
        keys = _.sortBy(keys);
        const ordered = {};
        _.each(keys, (k) => {
          ordered[k] = _.sortBy(naAuditGrouped[k], 'Reception');
        });
        console.log('naAuditGrouped', naAuditGrouped);
        const res = {
          naAuditGrouped: ordered,
          naNoAuditGrouped,
        };
        // console.log(res);
        return res;
      }
      return [];
    },
  },
  async mounted() {
    await this.fetchAuditList();
    await this.detectPeriod();
    this.datesLoaded = true;
    await this.fetchCustomerList();
    await this.fetchCustomers();
    await this.fetchNonPaidCustomerDates();
  },
  watch: {
    async from() {
      if (!this.datesLoaded) return;
      await this.fetchCustomerList();
    },
    async to() {
      if (!this.datesLoaded) return;
      await this.fetchCustomerList();
    },
  },
  methods: {
    async fetchNonPaidCustomerDates() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/audit/non-paid-audit-months`);
      console.log(data);
      this.nonPaidCustomerDates = data;
    },
    async detectPeriod() {
      const shiftDays = 2;
      const dayOfMonths = moment()
        .date();
      const start = 3 + shiftDays;
      const end = 18 + shiftDays;
      let from;
      let to;
      if (start <= dayOfMonths) {
        from = moment()
          .subtract(1, 'months')
          .set('date', 18);
        to = moment()
          .set('date', 3);
      } else if (start >= dayOfMonths && end <= dayOfMonths) {
        from = moment()
          .set('date', 3);
        to = moment()
          .set('date', 18);
      } else {
        from = moment()
          .set('date', 18);
        to = moment()
          .add(1, 'months')
          .set('date', 3);
      }
      this.from = from.format('YYYY-MM-DD');
      this.to = to.format('YYYY-MM-DD');
    },
    async fetchCustomerList() {
      if (!(this.from && this.to)) {
        return;
      }
      const query = queryString.stringify({
        from: this.from,
        to: this.to,
      });
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/audit/customer-list?${query}`);
      this.customersToAudit = data.customersToAudit;
      this.closedAudit = data.closedAudit;
    },

    async fetchAuditList() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/audit/audit-list`);
      this.auditList = data;
    },
    async makeAudit() {
      if (!confirm('Создать новую сверку?')) {
        return;
      }
      const query = queryString.stringify({
        customer_id: this.customer_id,
        handMade: true,
      });
      await get(`${process.env.VUE_APP_API_HOST}admin/audit/make-audit-list/${this.date_start}/${this.date_end}?${query}`);
      await this.fetchAuditList();
    },

    async fetchCustomers() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/customer`);
      this.customers = data;
    },
    toggleCollapse(groupName) {
      this.$set(this.collapse, groupName, !this.collapse[groupName]);
    },
  },
};
</script>
<style lang="scss">
#audit-customer-list {
  table {
    tr.bg-success {
      background-color: #a1f5b4 !important;

      td {
        border-color: #69c169 !important;
      }
    }

    tr.bg-danger {
      background-color: #ffb9c0 !important;

      td {
        border-color: #c38e94 !important;
      }
    }
  }
}
</style>
